import React from "react";
import useTranslation from "../../hooks/useTranslation";

export default function HighRiskPatientsCard({ patients }) {
  const { t } = useTranslation();
  const highRiskPatients = patients.filter(p => p.status === "High Risk");
  return (
    <div className="admin-panel" style={{ marginTop: 12 }}>
      <div className="admin-panel-title">{t('High Risk Patients')}</div>
      {highRiskPatients.length === 0 ? (
        <div className="admin-muted">{t('No high-risk patients currently')}</div>
      ) : (
        <table className="admin-table">
          <thead>
            <tr>
              <th>{t('Name')}</th>
              <th>{t('Doctor')}</th>
              <th>{t('Status')}</th>
              <th>{t('Contact')}</th>
            </tr>
          </thead>
          <tbody>
            {highRiskPatients.map((p) => (
              <tr key={p.id}>
                <td>{p.name}</td>
                <td>{p.doctor_name || t("Unassigned")}</td>
                <td><span className="badge badge-danger">{t('High Risk')}</span></td>
                <td>{p.contact || t("N/A")}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
